import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import { CardOutline } from "components/Card";

type Props = { query: string };
export default function TableNoData({ query }: Props) {
  return (
    <TableRow>
      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
        <CardOutline
          sx={{
            textAlign: "center",
            py: 4,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Not found
          </Typography>

          <Typography variant="body2" sx={{ mb: 1 }}>
            No results found for &nbsp;
            <strong>&quot;{query}&quot;</strong>.
          </Typography>
          <Typography variant="body2">
            Try checking for typos or using complete words.
          </Typography>
        </CardOutline>
      </TableCell>
    </TableRow>
  );
}
